/* eslint-disable react/no-array-index-key */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { ICashFlowBudgetClassification } from 'views/ProFormaTable/types';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import RenderIf from 'components/RenderIf/RenderIf';
import { getProjectActualsCategoryLevelTotals } from 'views/ProFormaTable/helpers';
import { useProFormaSocketContext } from 'views/ProFormaTable/components/ProForma/socketContext/ProFormaSocketProvider';
import { Periods } from 'components/ProFormaReturnsTable/constant';
import { useUsesActualsTableContext } from '../../context/UsesTableActualsProvider';
import UsesTableBudgetLineActuals from './UsesTableBudgetLineActuals/UsesTableBudgetLineActuals';
import ProjectActualsCashFlowPeriods from '../../ProjectActualsCashFlowPeriods/ProjectActualsCashFlowPeriods';

export interface IUsesTableSubcategoryActuals {
    subcategory: ICashFlowBudgetClassification;
}

const UsesTableSubcategoryActuals = ({ subcategory }: IUsesTableSubcategoryActuals) => {
    const { periodCadence, showCents } = useProFormaSocketContext();

    const {
        expandedActualsCategories, updateExpandedActualsCategories,
        forecastMetric, isEarlyPlanningProject, selectedScenario,
    } = useUsesActualsTableContext();

    const showCentsFormat = showCents ? '$0,0.00' : '$0,0';

    const categoryTotals = getProjectActualsCategoryLevelTotals(forecastMetric, subcategory, isEarlyPlanningProject, selectedScenario);

    let periods = subcategory.periodData || [];
    if (periodCadence === Periods.ANNUALLY) {
        periods = subcategory.yearlyPeriodData || [];
    }

    return (
        <>
            <tr className="NSTable__tbody__tr NSTable__tbody__tr--level-2 text-dark">
                <td
                    className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border
                    d-flex justify-content-between align-items-center flex-nowrap"
                >
                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                            <RenderIf isTrue={Boolean(subcategory.children?.length)}>
                                <FontAwesomeIcon
                                    className="icon ml-1 mr-2 ReadOnlyWrapper--enable-pointer-events text-dark"
                                    role="presentation"
                                    onClick={() => updateExpandedActualsCategories(null, subcategory.id)}
                                    icon={expandedActualsCategories.subcategories.includes(subcategory.id) ? faCaretDown : faCaretRight}
                                    fixedWidth
                                />
                            </RenderIf>
                            {subcategory.description}
                        </div>
                    </div>
                </td>
                <td className="NSTable__tbody__tr__td" />
                <td className="NSTable__tbody__tr__td">
                    <div className="d-flex justify-content-end">{numeralFormatterCurrency(categoryTotals.budgetTotal, showCentsFormat)}</div>
                </td>
                <td className="NSTable__tbody__tr__td">
                    <div className="d-flex justify-content-end">{numeralFormatterCurrency(categoryTotals.balanceRemaining, showCentsFormat)}</div>
                </td>
                <td className="NSTable__tbody__tr__td" />
                <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border" />

                <ProjectActualsCashFlowPeriods
                    periods={periods}
                    showCentsFormat={showCentsFormat}
                />
            </tr>

            <RenderIf isTrue={expandedActualsCategories.subcategories.includes(subcategory.id)}>
                {(subcategory.children || []).map(budgetClassification => (
                    <UsesTableBudgetLineActuals
                        key={budgetClassification.nodeName}
                        budgetClassification={budgetClassification}
                    />
                ))}
            </RenderIf>
        </>
    );
};

export default UsesTableSubcategoryActuals;
